import { db } from '../config/firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';

const COLLECTION = 'comerciales';

/**
 * Registra (o refresca) al usuario en el padrón de comerciales cuando ingresa
 * con el rol Comercial. El doc id es el uid de Firebase Auth, así cada usuario
 * aparece una sola vez sin importar cuántas veces se loguee.
 *
 * Este padrón alimenta los selects de "Comercial" en los formularios, en lugar
 * de listas hardcodeadas.
 */
export const registerComercialLogin = (user) => {
  try {
    return setDoc(doc(db, COLLECTION, user.uid), {
      nombre: user.displayName || '',
      email: user.email || '',
      ultimoLoginAt: serverTimestamp(),
      active: true,
    }, { merge: true });
  } catch (error) {
    console.error('comercialesService.registerComercialLogin failed:', { uid: user?.uid, error });
    throw error;
  }
};
